import Organizations_AccessTokens_MyAccessTokensPage from "@Organizations/AccessTokens/Pages/MyAccessTokensPage.vue";

export const routes = [
    // pages
    {
        path: "/organizations/accesstokens/my",
        component: Organizations_AccessTokens_MyAccessTokensPage
    },
]
